module.exports = {"blocks":[{"type":"sections/tw/contact","prefix":"contact"}],"contact_content":{"form":{"url":"https://docs.google.com/forms/d/1Z5CO70AHJzB6NeH1s23YF-xEWw5aAPsc9WAV1u4llHQ","name_name":"entry.513304797","name_email":"entry.724799615","name_phone_number":"entry.2144922500","name_title":"entry.1661687659","name_message":"entry.210873863"}}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/tw/setting/contact/setting.json
// module id = 732
// module chunks = 0 1 2 3 4 5